import { Box, Button } from "@mui/material";
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks";
import { selectCampaignAddressById } from "../../../../../store/reducers/awareness_campaigns/addresses";
import CustomNavIcon from "../../../../_include/icons/CustomNavIcon";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded';
import { Namespace } from "../../../../../locales/translations";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import NavigationDialog from "../../../NavigationDialog";
import { AddressReportActions } from "../../../../../store/reducers/awareness_campaigns/address_report";

type AddressItemActionsProps = {
    addressID: EntityId;
}

export default function AddressItemActions({ addressID }: AddressItemActionsProps) {

    const { t } = useTranslation([Namespace.ACTIONS]);

    const addressData = useAppSelector(state => selectCampaignAddressById(state, addressID));

    const [isNavigationModalOpen, setIsNavigationModalOpen] = useState(false);

    const handleNavigationIconClick = (event: React.MouseEvent) => {
        event.stopPropagation(); // Prevent list item click
        setIsNavigationModalOpen(true);
    };

    const dispatch = useAppDispatch();

    if (!addressData) return null;

    const handleSensitizedClick = () => {
        dispatch(AddressReportActions.openReportForm(addressData));
    }

    return (
        <Box display="flex" justifyContent="center" mb={2}>
            <Box display="flex" alignItems="center" gap={2} maxWidth={400}>
                <Button
                    variant="outlined"
                    color="secondary"
                    endIcon={<CustomNavIcon />}
                    onClick={handleNavigationIconClick}
                    disabled={!addressData.lat || !addressData.lng}
                >
                    {t('navigate', { ns: Namespace.ACTIONS })}
                </Button>

                <Button
                    variant={addressData?.visited ? "contained" : "outlined"}
                    color="success"
                    endIcon={addressData?.visited ? <CheckRoundedIcon /> : <ContactSupportRoundedIcon />}
                    onClick={handleSensitizedClick}
                    disableElevation
                    sx={{
                        ...(addressData?.visited && {
                            color: "#fff",
                        }),
                    }}
                >
                    {t('sensitized', { ns: Namespace.ACTIONS })}
                </Button>
            </Box>


            {/* Navigation Dialog */}
            {addressData.lat && addressData.lng ? (
                <NavigationDialog
                    open={isNavigationModalOpen}
                    onClose={() => setIsNavigationModalOpen(false)}
                    variant="location"
                    coordinates={{
                        lat: addressData.lat,
                        lng: addressData.lng
                    }}
                />
            ) : null}
        </Box>
    )
}